import { useCallback } from 'react';
import { FormButtons } from './Header.Editing.FormButtons';
import { useGroupTags, useGroupTagsDispatch, useGroupTagsUpdate, useGroupTagsReset } from './hooks';

export default function Editing() {
  const { tags } = useGroupTags();
  const dispatch = useGroupTagsDispatch();
  const [update, canUpdate] = useGroupTagsUpdate();
  const reset = useGroupTagsReset();

  const handleSave = useCallback(() => {
    update(tags);
    dispatch(state => ({ ...state, editing: false }));
  }, [dispatch, update, tags]);

  const handleCancel = useCallback(() => {
    reset();
    dispatch(state => ({ ...state, editing: false }));
  }, [dispatch, reset]);

  return (
    <FormButtons
      disabled={!canUpdate}
      onSave={handleSave}
      onCancel={handleCancel} />
  );
}

export { Editing };